import { render, staticRenderFns } from "./HeaderLogoIcon.vue?vue&type=template&id=463d1c16&"
import script from "./HeaderLogoIcon.vue?vue&type=script&lang=js&"
export * from "./HeaderLogoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports